<template>
  <el-container class="standalone-layout">
    <el-aside :width="sidebarCollapsed ? '64px' : '208px'" class="standalone-layout__aside" :class="{ 'is-collapsed': sidebarCollapsed }">
      <div class="standalone-layout__brand">{{ sidebarCollapsed ? '智运' : '在途智运' }}</div>
      <el-menu
        :default-active="$route.path"
        background-color="#001827"
        text-color="#cbd5e1"
        active-text-color="#ffffff"
        router
        :default-openeds="openGroups"
        :collapse="sidebarCollapsed"
        :collapse-transition="false"
      >
        <authorized-menu v-for="item in menus" :key="item.id" :item="item" />
      </el-menu>
      <div class="standalone-layout__account">
        <div v-if="!sidebarCollapsed" class="standalone-layout__username"><i class="el-icon-user-solid" />{{ currentUser ? currentUser.username : '当前用户' }}</div>
        <el-button type="text" icon="el-icon-switch-button" title="退出登录" aria-label="退出登录" @click="handleLogout"><span v-if="!sidebarCollapsed">退出登录</span></el-button>
      </div>
    </el-aside>
    <el-main class="standalone-layout__main">
      <div class="standalone-layout__breadcrumb"><button class="standalone-layout__toggle" type="button" :title="sidebarCollapsed ? '展开侧栏' : '收起侧栏'" :aria-label="sidebarCollapsed ? '展开侧栏' : '收起侧栏'" :aria-expanded="String(!sidebarCollapsed)" @click="toggleSidebar"><i :class="{ 'el-icon-s-unfold': sidebarCollapsed, 'el-icon-s-fold': !sidebarCollapsed }" /></button><span>{{ systemPage ? '系统管理' : '业务功能' }}</span><span class="breadcrumb-divider">/</span><strong>{{ pageTitle }}</strong><el-tag v-if="currentUser" size="mini" :type="currentUser.superAdmin ? 'warning' : 'info'">{{ currentUser.superAdmin ? '超级管理员' : currentUser.accountType === 'SUB' ? '子账号' : '主账号' }}</el-tag></div>
      <router-view />
    </el-main>
  </el-container>
</template>

<script>
import { authState, logout } from '@/utils/auth'
import { buildNavigation } from '@/utils/permissionNavigation'
import AuthorizedMenu from '@/components/AuthorizedMenu.vue'

export default {
  name: 'StandaloneLayout',
  components: { AuthorizedMenu },
  data() { return { sidebarCollapsed: false } },
  computed: {
    currentUser() { return authState.user },
    menus() { return buildNavigation(this.currentUser && this.currentUser.menus) },
    openGroups() { return this.menus.filter(item => item.children.length).map(item => String(item.id)) },
    systemPage() { return ['/users', '/roles', '/menus', '/dictionaries', '/settings', '/api-audits', '/api-docs', '/callback-settings'].includes(this.$route.path) },
    pageTitle() { return this.$route.meta.title || '在途智运' }
  },
  methods: {
    toggleSidebar() {
      this.sidebarCollapsed = !this.sidebarCollapsed
      this.$nextTick(() => window.dispatchEvent(new Event('resize')))
    },
    async handleLogout() {
      try { await logout() } catch (error) { /* 服务不可用时仍清理本地登录状态 */ }
      await this.$router.replace('/login')
    }
  }
}
</script>

<style scoped>
.standalone-layout {
  width: 100%;
  min-width: 1024px;
  height: 100%;
}

.standalone-layout__aside {
  display: flex;
  flex-direction: column;
  background: #001827;
}

.standalone-layout__brand {
  height: 64px;
  color: #fff;
  font-size: 22px;
  font-weight: 600;
  line-height: 64px;
  text-align: center;
}

.standalone-layout__aside .el-menu {
  flex: 1;
  border-right: 0;
}

.standalone-layout__aside ::v-deep .el-menu-item.is-active { background-color: #1677ff !important; }

.standalone-layout__account { padding: 14px 18px 18px; border-top: 1px solid rgba(255, 255, 255, .1); }
.standalone-layout__username { overflow: hidden; margin-bottom: 8px; color: #dbe5f1; text-overflow: ellipsis; white-space: nowrap; }
.standalone-layout__username i { margin-right: 8px; }
.standalone-layout__account .el-button { padding: 0; color: #9fb1c7; }
.standalone-layout__aside.is-collapsed .standalone-layout__account { padding: 18px 0; text-align: center; }

.standalone-layout__main {
  min-width: 0;
  padding: 0 18px 18px;
  background: #f3f6fa;
  overflow: auto;
}
.standalone-layout__breadcrumb { display: flex; gap: 14px; align-items: center; height: 60px; color: #7e8995; }
.standalone-layout__toggle { display: inline-flex; align-items: center; justify-content: center; width: 28px; height: 32px; padding: 0; border: 0; background: transparent; color: inherit; font-size: 22px; cursor: pointer; }
.standalone-layout__toggle:focus-visible { outline: 2px solid #1677ff; outline-offset: 2px; }
.standalone-layout__breadcrumb strong { color: #1677ff; font-weight: 500; }
.standalone-layout__breadcrumb .el-tag { margin-left: auto; }
.breadcrumb-divider { color: #bdc5cf; }
</style>
